import { buildTimeChipSlots, formatTimeChip } from "./TimeChipGrid";
import { isTimeAlignedToSlotInterval, MIN_SLOT_INTERVAL_MINUTES, normalizeSlotIntervalMinutes } from "@/lib/calendarGranularity";

function normalizeSlot(slot) {
  if (typeof slot === "string") {
    return { time: slot, available: true };
  }
  const time = slot?.time || slot?.slot_time || slot?.value || "";
  return {
    time: String(time).slice(0, 5),
    available: slot?.available !== false,
  };
}

export function buildTimeSelectOptions(slots = buildTimeChipSlots(), slotIntervalMinutes = MIN_SLOT_INTERVAL_MINUTES) {
  const interval = normalizeSlotIntervalMinutes(slotIntervalMinutes);
  const seen = new Set();
  return slots
    .map(normalizeSlot)
    .filter((slot) => slot.time && slot.available && isTimeAlignedToSlotInterval(slot.time, interval))
    .filter((slot) => {
      if (seen.has(slot.time)) return false;
      seen.add(slot.time);
      return true;
    })
    .sort((a, b) => a.time.localeCompare(b.time));
}

export default function TimeSelect({
  value,
  onChange,
  slots = buildTimeChipSlots(),
  testId = "time-select",
  className = "",
  placeholder = "Pick time",
  emptyLabel = "No available times",
  disabled = false,
  slotIntervalMinutes = MIN_SLOT_INTERVAL_MINUTES,
}) {
  const interval = normalizeSlotIntervalMinutes(slotIntervalMinutes);
  const options = buildTimeSelectOptions(slots, interval);
  const selectedValue = options.some((slot) => slot.time === value) ? value : "";
  const isDisabled = disabled || options.length === 0;

  return (
    <select
      value={selectedValue}
      onChange={(event) => onChange(event.target.value)}
      data-testid={testId}
      disabled={isDisabled}
      className={className}
    >
      <option value="">{options.length ? placeholder : emptyLabel}</option>
      {options.map((slot) => (
        <option key={slot.time} value={slot.time}>
          {formatTimeChip(slot.time)}
        </option>
      ))}
    </select>
  );
}
